import { BrowserProvider, Contract, toQuantity } from 'ethers';
import { fetchData } from '../data/dataActions';

const connectRequest = () => ({
  type: 'CONNECTION_REQUEST',
});

const connectSuccess = (payload) => ({
  type: 'CONNECTION_SUCCESS',
  payload: payload,
});

const connectFailed = (payload) => ({
  type: 'CONNECTION_FAILED',
  payload: payload,
});

const updateAccountRequest = (payload) => ({
  type: 'UPDATE_ACCOUNT',
  payload: payload,
});

export const connect = () => {
  return async (dispatch) => {
    dispatch(connectRequest());
    try {
      const abiResponse = await fetch('/config/abi.json', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });
      const abi = await abiResponse.json();

      const configResponse = await fetch('/config/config.json', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });
      const CONFIG = await configResponse.json();

      const { ethereum } = window;
      if (!ethereum || !ethereum.isMetaMask) {
        return dispatch(connectFailed('Please install Metamask.'));
      }

      const provider = new BrowserProvider(ethereum);
      const signer = await provider.getSigner();
      const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
      const network = await provider.getNetwork();

      if (network.chainId !== CONFIG.NETWORK.ID) {
        const chainIdHex = toQuantity(CONFIG.NETWORK.ID);
        try {
          await ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: chainIdHex }],
          });
        } catch (switchError) {
          if (switchError.code === 4902) {
            dispatch(connectFailed(`Please add ${CONFIG.NETWORK.NAME} network to Metamask.`));
          } else {
            dispatch(connectFailed('Failed to switch network.'));
          }
          return;
        }
      }

      const contract = new Contract(CONFIG.CONTRACT_ADDRESS, abi, signer);

      dispatch(
        connectSuccess({
          account: accounts[0],
          smartContract: contract,
          provider: provider,
        })
      );

      // Listeners
      ethereum.on('accountsChanged', (accounts) => {
        dispatch(updateAccount(accounts[0]));
      });

      ethereum.on('chainChanged', () => {
        window.location.reload();
      });
    } catch (err) {
      console.error(err);
      dispatch(connectFailed('Something went wrong.'));
    }
  };
};

export const updateAccount = (account) => {
  return async (dispatch) => {
    dispatch(updateAccountRequest({ account }));
    dispatch(fetchData(account));
  };
};
